@file:OptIn(ExperimentalMaterial3Api::class, ExperimentalFoundationApi::class, ExperimentalLayoutApi::class)

package com.example.monetix.ui.dialogs

import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.tween
import androidx.compose.ui.draw.blur
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.snapping.rememberSnapFlingBehavior
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.AddCircleOutline
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.material.icons.filled.ArrowDownward
import androidx.compose.material.icons.filled.AccountBalanceWallet
import androidx.compose.material.icons.filled.CalendarMonth
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.material.icons.filled.MoreVert
import androidx.compose.material.icons.filled.Search
import androidx.compose.material.icons.outlined.CameraAlt
import androidx.compose.material.icons.outlined.Delete
import androidx.compose.material.icons.outlined.Mic
import androidx.compose.material.icons.outlined.Search
import androidx.compose.material3.*
import com.example.monetix.ui.components.MonetixTextField as OutlinedTextField
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsFocusedAsState
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.compose.ui.window.PopupProperties
import coil3.compose.AsyncImage
import com.example.monetix.BankNotificationData
import com.example.monetix.db.PiggyBankEntity
import com.example.monetix.HomeViewModel
import com.example.monetix.TYPE_EXPENSE
import com.example.monetix.TYPE_INCOME
import com.example.monetix.TYPE_TRANSFER
import com.example.monetix.db.MonetixDatabase
import com.example.monetix.db.AccountEntity
import com.example.monetix.db.CategoryEntity
import com.example.monetix.db.FinancingEntity
import com.example.monetix.db.RecurringExpenseEntity
import com.example.monetix.db.SavingsGoalEntity
import com.example.monetix.db.TransactionEntity
import com.example.monetix.formatEuroFromCents
import com.example.monetix.stripSystemMarker
import com.example.monetix.ui.components.MonetixGlassSwitch
import com.example.monetix.utils.rememberMediaHandler
import com.example.monetix.utils.autoFaviconUrlForName
import com.example.monetix.utils.rememberReceiptScanner
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.datetime.todayIn
import kotlin.random.Random
import kotlin.math.roundToInt
import kotlinx.coroutines.Dispatchers
import com.example.monetix.ui.screens.WheelPicker
import com.example.monetix.ui.components.TxLogo
import com.example.monetix.utils.BankNotificationCatcher
import com.example.monetix.utils.rememberLocationTracker
import com.example.monetix.utils.SmartLocationEngine
import com.russhwolf.settings.Settings

data class PendingCashTx(
    val amountCents: Long,
    val merchant: String,
    val categoryId: String?,
    val categoryName: String,
    val desc: String
)

fun String.cleanDisplayName(): String {
    return stripSystemMarker(this)?.trim() ?: ""
}

private data class PredefMerchant(
    val name: String,
    val suggestedCategory: String,
    val suggestedSubcategory: String,
    val domain: String? = null,
    val emoji: String? = null,
    val customUrl: String? = null
) {
    val url get() = customUrl ?: domain?.let { "https://icon.horse/icon/$it" }
}

private val defaultMerchantSuggestions = listOf(
    PredefMerchant("Amazon", "SHOPPING", "E-commerce", "amazon.it"),
    PredefMerchant("Lidl", "SPESA", "Supermercato", "lidl.it"),
    PredefMerchant("Esselunga", "SPESA", "Supermercato", "esselunga.it"),
    PredefMerchant("Conad", "SPESA", "Supermercato", "conad.it"),
    PredefMerchant("Coop", "SPESA", "Supermercato", "e-coop.it"),
    PredefMerchant("Eurospin", "SPESA", "Supermercato", "eurospin.it"),
    PredefMerchant("Carrefour", "SPESA", "Supermercato", "carrefour.it"),
    PredefMerchant("Netflix", "RISTORANTI E SVAGO", "Streaming", "netflix.com"),
    PredefMerchant("Spotify", "RISTORANTI E SVAGO", "Streaming", domain = "spotify.com"),
    PredefMerchant("McDonald's", "RISTORANTI E SVAGO", "Fast Food", "mcdonalds.it"),
    PredefMerchant("Deliveroo", "RISTORANTI E SVAGO", "Delivery", "deliveroo.it"),
    PredefMerchant("Just Eat", "RISTORANTI E SVAGO", "Delivery", "justeat.it"),
    PredefMerchant("Q8", "AUTO E TRASPORTI", "Carburante", emoji = "⛽"),
    PredefMerchant("Eni Station", "AUTO E TRASPORTI", "Carburante", emoji = "⛽"),
    PredefMerchant("IP", "AUTO E TRASPORTI", "Carburante", emoji = "⛽"),
    PredefMerchant("Telepass", "AUTO E TRASPORTI", "Pedaggi", emoji = "🛣️"),
    PredefMerchant("Trenitalia", "AUTO E TRASPORTI", "Biglietti Trasporto", "trenitalia.com"),
    PredefMerchant("Acqua & Sapone", "CASA E BOLLETTE", "Igiene", emoji = "🧼"),
    PredefMerchant("Tigotà", "CASA E BOLLETTE", "Igiene", emoji = "🧼"),
    PredefMerchant("IKEA", "CASA E BOLLETTE", "Arredamento", "ikea.com"),
    PredefMerchant("Farmacia", "SALUTE", "Farmaci", emoji = "💊"),
    PredefMerchant("Stipendio", "STIPENDIO E ENTRATE", "Stipendio Mensile", emoji = "💶"),
    PredefMerchant("Satispay", "SHOPPING", "Pagamenti Smart", "satispay.com")
)

private fun detectSmartMerchant(input: String): PredefMerchant? {
    val cleanInput = input.trim().lowercase()
    if (cleanInput.length < 3) return null
    return defaultMerchantSuggestions.firstOrNull { it.name.lowercase().contains(cleanInput) }
}

private val semanticCategories = mapOf(
    "Abbigliamento" to listOf("maglietta", "scarpe", "pantaloni", "giacca", "vestito", "camicia", "abbigliamento"),
    "Carburante" to listOf("gasolio", "benzina", "diesel", "rifornimento", "pieno"),
    "Ristoranti e Svago" to listOf("pizza", "cena", "pranzo", "ristorante", "aperitivo", "caffè", "bar"),
    "Spesa" to listOf("spesa", "cibo", "supermercato", "latte", "pane")
)

@Composable
private fun StableWebTextField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    modifier: Modifier = Modifier,
    trailingIcon: @Composable (() -> Unit)? = null,
    leadingIcon: @Composable (() -> Unit)? = null,
    enabled: Boolean = true,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    keyboardType: KeyboardType = KeyboardType.Text
) {
    OutlinedTextField(
        value = value,
        onValueChange = onValueChange,
        label = { Text(label, style = MaterialTheme.typography.labelSmall) },
        maxLines = 1,
        enabled = enabled,
        modifier = modifier.fillMaxWidth().onFocusChanged { focusState -> 
            if (focusState.isFocused && value != "") {
                onValueChange("")
            }
        },
        shape = RoundedCornerShape(14.dp),
        trailingIcon = trailingIcon,
        leadingIcon = leadingIcon,
        interactionSource = interactionSource,
        keyboardOptions = KeyboardOptions(
            keyboardType = keyboardType,
            autoCorrectEnabled = false
        ),
        colors = OutlinedTextFieldDefaults.colors(
            focusedTextColor = Color.White,
            unfocusedTextColor = Color.White,
            focusedContainerColor = Color.Black.copy(alpha = 0.35f),
            unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
            focusedBorderColor = Color.White.copy(alpha = 0.40f),
            unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
            focusedLabelColor = Color.White,
            unfocusedLabelColor = Color(0xFFA0A0A0)
        )
    )
}

@Composable
private fun StableWebNumberField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    modifier: Modifier = Modifier,
    trailingIcon: @Composable (() -> Unit)? = null,
    leadingIcon: @Composable (() -> Unit)? = null,
    enabled: Boolean = true,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
) {
    OutlinedTextField(
        value = value,
        onValueChange = { newVal ->
            if (newVal.all { c -> c.isDigit() || c == ',' || c == '.' || c == ' ' }) onValueChange(newVal)
        },
        label = { Text(label, style = MaterialTheme.typography.labelSmall) },
        maxLines = 1,
        enabled = enabled,
        modifier = modifier.fillMaxWidth().onFocusChanged { focusState -> 
            if (focusState.isFocused && value != "") {
                onValueChange("")
            }
        },
        shape = RoundedCornerShape(14.dp),
        trailingIcon = trailingIcon,
        leadingIcon = leadingIcon,
        interactionSource = interactionSource,
        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal, autoCorrectEnabled = false),
        colors = OutlinedTextFieldDefaults.colors(
            focusedTextColor = Color.White,
            unfocusedTextColor = Color.White,
            focusedContainerColor = Color.Black.copy(alpha = 0.35f),
            unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
            focusedBorderColor = Color.White.copy(alpha = 0.40f),
            unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
            focusedLabelColor = Color.White,
            unfocusedLabelColor = Color(0xFFA0A0A0)
        )
    )
}

@OptIn(ExperimentalFoundationApi::class)
@Composable
private fun AmountWheelDialog(
    initialAmount: String,
    onDismiss: () -> Unit,
    onConfirm: (String) -> Unit
) {
    val cleanInitial = initialAmount.replace(",", ".").ifBlank { "0.00" }
    val parts = cleanInitial.split(".")
    val initEuro = parts.getOrNull(0)?.toIntOrNull() ?: 0
    val initCents = parts.getOrNull(1)?.padEnd(2, '0')?.take(2)?.toIntOrNull() ?: 0

    val euros = (0..9999).toList()
    val cents = (0..99).toList()

    val euroState = rememberLazyListState(initialFirstVisibleItemIndex = initEuro)
    val centState = rememberLazyListState(initialFirstVisibleItemIndex = initCents)

    AlertDialog(
        onDismissRequest = onDismiss,
        shape = RoundedCornerShape(28.dp),
        containerColor = Color.White.copy(alpha = 0.12f),
        title = { Text("Seleziona Importo", style = MaterialTheme.typography.titleMedium, color = Color.White) },
        text = {
            Row(
                modifier = Modifier.fillMaxWidth().height(180.dp),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically
            ) {
                LazyColumn(
                    state = euroState,
                    flingBehavior = rememberSnapFlingBehavior(euroState),
                    modifier = Modifier.weight(1f).height(150.dp),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    contentPadding = PaddingValues(vertical = 55.dp)
                ) {
                    items(euros.size) { i ->
                        val isSelected by remember { derivedStateOf { euroState.firstVisibleItemIndex == i } }
                        Text(
                            text = "${euros[i]}",
                            fontSize = if (isSelected) 28.sp else 18.sp,
                            fontWeight = if (isSelected) FontWeight.Bold else FontWeight.Normal,
                            color = if (isSelected) MaterialTheme.colorScheme.primary else Color.White.copy(alpha = 0.4f),
                            modifier = Modifier.padding(vertical = 6.dp)
                        )
                    }
                }
                Text(",", fontSize = 32.sp, fontWeight = FontWeight.Bold, modifier = Modifier.padding(horizontal = 8.dp))
                LazyColumn(
                    state = centState,
                    flingBehavior = rememberSnapFlingBehavior(centState),
                    modifier = Modifier.weight(1f).height(150.dp),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    contentPadding = PaddingValues(vertical = 55.dp)
                ) {
                    items(cents.size) { i ->
                        val isSelected by remember { derivedStateOf { centState.firstVisibleItemIndex == i } }
                        Text(
                            text = cents[i].toString().padStart(2, '0'),
                            fontSize = if (isSelected) 28.sp else 18.sp,
                            fontWeight = if (isSelected) FontWeight.Bold else FontWeight.Normal,
                            color = if (isSelected) MaterialTheme.colorScheme.primary else Color.White.copy(alpha = 0.4f),
                            modifier = Modifier.padding(vertical = 6.dp)
                        )
                    }
                }
            }
        },
        confirmButton = {
            Button(onClick = {
                val e = euros[euroState.firstVisibleItemIndex]
                val c = cents[centState.firstVisibleItemIndex].toString().padStart(2, '0')
                onConfirm("$e,$c")
            }) { Text("CONFERMA") }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) { Text("ANNULLA") }
        }
    )
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun WebImagePickerPopup(
    initialQuery: String,
    onDismiss: () -> Unit,
    onImageSelected: (String) -> Unit
) {
    var query by remember { mutableStateOf(initialQuery) }
    var results by remember { mutableStateOf<List<String>>(emptyList()) }
    val uriHandler = LocalUriHandler.current

    val popularBrands = remember {
        listOf("Amazon", "Netflix", "Spotify", "PayPal", "Iliad", "Postepay", "Enel", "Trenitalia", "Conad", "Coop", "McDonald's", "Apple", "Uber", "Deliveroo")
    }

    fun generateLinks(qRaw: String) {
        val q = qRaw.trim().lowercase().replace(" ", "")
        if (q.isEmpty()) {
            results = emptyList()
            return
        }
        val domain = if (q.contains(".")) q else "$q.com"
        val domainIt = if (q.contains(".")) q else "$q.it"

        results = listOf(
            "https://unavatar.io/$domain",
            "https://unavatar.io/$domainIt",
            "https://icon.horse/icon/$domain",
            "https://icon.horse/icon/$domainIt",
            "https://www.google.com/s2/favicons?domain=$domain&sz=128",
            "https://www.google.com/s2/favicons?domain=$domainIt&sz=128"
        ).distinct()
    }

    LaunchedEffect(initialQuery) {
        if (initialQuery.isNotBlank()) generateLinks(initialQuery)
    }

    AlertDialog(
        onDismissRequest = onDismiss,
        shape = RoundedCornerShape(28.dp),
        containerColor = Color(0xFF1E1B4B),
        title = {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Surface(
                    shape = CircleShape,
                    color = Color(0xFF60A5FA).copy(alpha = 0.2f),
                    modifier = Modifier.size(36.dp)
                ) {
                    Icon(
                        imageVector = Icons.Default.Search,
                        contentDescription = null,
                        tint = Color(0xFF60A5FA),
                        modifier = Modifier.padding(8.dp)
                    )
                }
                Spacer(Modifier.width(12.dp))
                Column {
                    Text(
                        "Ricerca Logo Web 🌐",
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = Color.White
                    )
                    Text(
                        "Trova il logo ufficiale del merchant",
                        style = MaterialTheme.typography.labelSmall,
                        color = Color.White.copy(alpha = 0.6f)
                    )
                }
            }
        },
        text = {
            Column(
                modifier = Modifier.fillMaxWidth().verticalScroll(rememberScrollState()),
                verticalArrangement = Arrangement.spacedBy(14.dp)
            ) {
                OutlinedTextField(
                    value = query,
                    onValueChange = {
                        query = it
                        generateLinks(it)
                    },
                    label = { Text("Brand o Nome Azienda", color = Color(0xFFA0A0A0)) },
                    placeholder = { Text("es. Netflix, Amazon, Iliad...", color = Color(0xFFA0A0A0)) },
                    trailingIcon = {
                        if (query.isNotBlank()) {
                            IconButton(onClick = { query = ""; results = emptyList() }) {
                                Icon(Icons.Default.Close, contentDescription = "Cancella", tint = Color.White.copy(alpha = 0.6f))
                            }
                        } else {
                            Icon(Icons.Default.Search, contentDescription = null, tint = Color(0xFF60A5FA))
                        }
                    },
                    singleLine = true,
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(14.dp),
                    colors = OutlinedTextFieldDefaults.colors(
                        focusedTextColor = Color.White,
                        unfocusedTextColor = Color.White,
                        focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                        unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                        focusedBorderColor = Color(0xFF60A5FA),
                        unfocusedBorderColor = Color.White.copy(alpha = 0.20f)
                    )
                )

                Text("Brand frequenti:", style = MaterialTheme.typography.labelSmall, color = Color.White.copy(alpha = 0.7f))
                LazyRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    items(popularBrands) { brand ->
                        FilterChip(
                            selected = query.equals(brand, ignoreCase = true),
                            onClick = { query = brand; generateLinks(brand) },
                            label = { Text(brand, fontSize = 11.sp, fontWeight = FontWeight.SemiBold) },
                            colors = FilterChipDefaults.filterChipColors(
                                selectedContainerColor = Color(0xFF60A5FA),
                                selectedLabelColor = Color.White,
                                containerColor = Color.White.copy(alpha = 0.08f),
                                labelColor = Color.White.copy(alpha = 0.8f)
                            ),
                            border = null
                        )
                    }
                }

                if (results.isNotEmpty()) {
                    Text("Tocca il logo da usare:", style = MaterialTheme.typography.labelSmall, color = Color.White.copy(alpha = 0.7f))
                    LazyVerticalGrid(
                        columns = GridCells.Adaptive(64.dp),
                        horizontalArrangement = Arrangement.spacedBy(10.dp),
                        verticalArrangement = Arrangement.spacedBy(10.dp),
                        modifier = Modifier.height(160.dp).fillMaxWidth()
                    ) {
                        items(results) { url ->
                            Surface(
                                modifier = Modifier
                                    .aspectRatio(1f)
                                    .clickable { onImageSelected(url) },
                                shape = RoundedCornerShape(16.dp),
                                color = Color.White.copy(alpha = 0.15f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f))
                            ) {
                                AsyncImage(
                                    model = url,
                                    contentDescription = null,
                                    modifier = Modifier.fillMaxSize().padding(10.dp),
                                    contentScale = ContentScale.Fit
                                )
                            }
                        }
                    }
                } else {
                    Box(modifier = Modifier.height(80.dp).fillMaxWidth(), contentAlignment = Alignment.Center) {
                        Text("Digita il nome di un brand per caricare i loghi", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                    }
                }

                HorizontalDivider(color = Color.White.copy(alpha = 0.10f))

                Button(
                    onClick = {
                        val q = if (query.isNotBlank()) "${query} logo icon" else "logo icon"
                        uriHandler.openUri("https://www.google.com/search?tbm=isch&q=${q.replace(" ", "+")}")
                    },
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(12.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color.White.copy(alpha = 0.12f), contentColor = Color.White)
                ) {
                    Icon(Icons.Outlined.Search, contentDescription = null, modifier = Modifier.size(18.dp), tint = Color(0xFF60A5FA))
                    Spacer(Modifier.width(8.dp))
                    Text("Cerca immagini su Google ↗", style = MaterialTheme.typography.labelMedium)
                }

                var manualUrl by remember { mutableStateOf("") }
                OutlinedTextField(
                    value = manualUrl,
                    onValueChange = { manualUrl = it },
                    label = { Text("O incolla URL immagine", color = Color(0xFFA0A0A0)) },
                    placeholder = { Text("https://...", color = Color(0xFFA0A0A0)) },
                    singleLine = true,
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(14.dp),
                    colors = OutlinedTextFieldDefaults.colors(
                        focusedTextColor = Color.White,
                        unfocusedTextColor = Color.White,
                        focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                        unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                        focusedBorderColor = Color(0xFF60A5FA),
                        unfocusedBorderColor = Color.White.copy(alpha = 0.20f)
                    )
                )

                AnimatedVisibility(visible = manualUrl.isNotBlank()) {
                    Column(
                        modifier = Modifier.fillMaxWidth().padding(top = 4.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Surface(
                            modifier = Modifier.size(64.dp),
                            shape = RoundedCornerShape(16.dp),
                            color = Color.White.copy(alpha = 0.15f),
                            border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f))
                        ) {
                            AsyncImage(
                                model = manualUrl.trim(),
                                contentDescription = "Anteprima URL",
                                modifier = Modifier.fillMaxSize().padding(8.dp),
                                contentScale = ContentScale.Fit
                            )
                        }
                        Spacer(Modifier.height(10.dp))
                        Button(
                            onClick = { onImageSelected(manualUrl.trim()) },
                            shape = RoundedCornerShape(12.dp),
                            colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF60A5FA), contentColor = Color.White)
                        ) {
                            Text("Usa questa immagine", fontWeight = FontWeight.Bold)
                        }
                    }
                }
            }
        },
        confirmButton = {},
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text("ANNULLA", color = Color.White.copy(alpha = 0.6f), fontWeight = FontWeight.Bold)
            }
        }
    )
}

enum class TxAmountTarget { NONE, AMOUNT, FEE }

@OptIn(ExperimentalMaterial3Api::class, ExperimentalFoundationApi::class, ExperimentalLayoutApi::class)
@Composable
fun AddOrTransferDialog(
    viewModel: HomeViewModel,
    db: MonetixDatabase,
    initialMode: String,
    saldoDisponibile: Long,
    categories: List<CategoryEntity>,
    accounts: List<AccountEntity>,
    latest: List<TransactionEntity>,
    activeAccountId: String?,
    onDismiss: () -> Unit,
    onSaveTx: (TransactionEntity) -> Unit,
    financings: List<FinancingEntity> = emptyList(),
    recurringItems: List<RecurringExpenseEntity> = emptyList(),
    savingsGoals: List<SavingsGoalEntity> = emptyList(),
    piggyBanks: List<PiggyBankEntity> = emptyList(),
    autoSweepEnabled: Boolean = false,
    sweepDestination: String = "SOGNI",
    initialBankData: BankNotificationData? = null,
    onBankDataConsumed: () -> Unit = {}
) {
    val brandPrimary = MaterialTheme.colorScheme.primary
    val scope = rememberCoroutineScope()
    var showSaldoWarning by remember { mutableStateOf(false) }
    var showCashWarning by remember { mutableStateOf(false) }
    var showCashExceededWarning by remember { mutableStateOf(false) }

    var showDuplicateWarning by remember { mutableStateOf<TransactionEntity?>(null) }

    // 🚀 STATI FONDO EMERGENZA PER AUTO-DRAIN
    var showSmartEmergencyWarning by remember { mutableStateOf(false) }
    var pendingEmergencyDeficit by remember { mutableStateOf(0L) }
    val settings = remember { Settings() }
    val emergencyTargetCents = remember { settings.getLong("emergency_fund_target", 500000L) }
    val today = Clock.System.todayIn(TimeZone.currentSystemDefault())

    val emergencyBalanceCents = remember(latest, today) {
        val todayEpochDays = today.toEpochDays().toLong()
        var sum = 0L
        for (tx in latest) {
            if (tx.isDeleted || tx.dateEpochDay > todayEpochDays) continue
            val isTarget = tx.accountId == "sys_emergency_fund" || tx.toAccountId == "sys_emergency_fund" || tx.fromAccountId == "sys_emergency_fund"
            if (!isTarget) continue
            when (tx.type) {
                "INCOME" -> if (tx.accountId == "sys_emergency_fund") sum += tx.amountCents
                "EXPENSE" -> if (tx.accountId == "sys_emergency_fund") sum -= tx.amountCents
                "TRANSFER" -> {
                    if (tx.fromAccountId == "sys_emergency_fund") sum -= tx.amountCents
                    if (tx.toAccountId == "sys_emergency_fund") sum += tx.amountCents
                }
            }
        }
        sum
    }

    val receiptScanner = rememberReceiptScanner()
    var isScanningReceipt by remember { mutableStateOf(false) }
    var isImageActionForOCR by rememberSaveable { mutableStateOf(false) }
    var receiptError by remember { mutableStateOf(false) }

    var amountText by remember { mutableStateOf(initialBankData?.amount ?: BankNotificationCatcher.currentNotification?.amount ?: "") }
    val amountInteractionSource = remember { MutableInteractionSource() }
    var merchant by remember { mutableStateOf(initialBankData?.merchant ?: BankNotificationCatcher.currentNotification?.merchant ?: "") }

    var feeText by remember { mutableStateOf("") }
    val feeInteractionSource = remember { MutableInteractionSource() }

    val pendingCashTxs = remember { mutableStateListOf<PendingCashTx>() }
    var showPendingCashPopup by remember { mutableStateOf(false) }

    var isSavingsActive by remember { mutableStateOf(false) }
    var percentageText by remember { mutableStateOf("10") }
    val savingsInteractionSource = remember { MutableInteractionSource() }
    val isSavingsFocused by savingsInteractionSource.collectIsFocusedAsState()

    LaunchedEffect(isSavingsFocused) {
        if (isSavingsFocused) percentageText = ""
    }

    val initialDateStr = "${today.dayOfMonth.toString().padStart(2, '0')}/${today.monthNumber.toString().padStart(2, '0')}/${today.year}"
    var dateTFV by remember { mutableStateOf(TextFieldValue(initialDateStr, TextRange(initialDateStr.length))) }
    val dateInteractionSource = remember { MutableInteractionSource() }
    val isDateFocused by dateInteractionSource.collectIsFocusedAsState()

    var reminderDays by remember { mutableStateOf(0L) }
    val isFutureDate = remember(dateTFV.text) {
        try {
            val parts = dateTFV.text.split("/")
            if (parts.size == 3) {
                val selectedDate = LocalDate(parts[2].toInt(), parts[1].toInt(), parts[0].toInt())
                selectedDate.toEpochDays() > today.toEpochDays()
            } else false
        } catch (e: Exception) { false }
    }

    LaunchedEffect(isDateFocused) {
        if (isDateFocused) dateTFV = TextFieldValue("", TextRange.Zero)
    }

    val onDateTFVChange: (TextFieldValue) -> Unit = { newVal ->
        val oldText = dateTFV.text
        val newText = newVal.text
        if (newText.length < oldText.length) {
            dateTFV = newVal
        } else {
            val clean = newText.replace("/", "").filter { it.isDigit() }
            val formatted = buildString {
                for (i in clean.indices) {
                    append(clean[i])
                    if ((i == 1 || i == 3) && i < 7) append("/")
                }
            }.take(10)
            dateTFV = TextFieldValue(formatted, TextRange(formatted.length))
        }
    }

    val mode = initialMode
    val isCashMode = mode == "CASH"
    var cashModeIsExpense by remember { mutableStateOf(true) }
    
    val isTransfer = mode == TYPE_TRANSFER
    val isIncome = mode == TYPE_INCOME || (isCashMode && !cashModeIsExpense)

    var desc by remember { mutableStateOf("") }
    var logoEmoji by remember { mutableStateOf("") }
    var logoUri by remember { mutableStateOf<String?>(null) }
    var manualLogoSet by remember { mutableStateOf(false) }

    val locationTracker = rememberLocationTracker()
    val locationEngine = remember(db, locationTracker) { SmartLocationEngine(db, locationTracker) }

    LaunchedEffect(Unit) {
        if (!isTransfer && merchant.isBlank()) {
            try {
                val suggestedMerchant = locationEngine.suggestMerchantNearby()
                if (!suggestedMerchant.isNullOrBlank()) {
                    merchant = suggestedMerchant
                }
            } catch (e: Exception) { }
        }
    }

    var selectedAccountId by remember { mutableStateOf(activeAccountId ?: accounts.firstOrNull { !it.isArchived && it.isVisible && !it.isDeleted }?.id) }
    var selectedFromAccountId by remember { mutableStateOf(activeAccountId ?: accounts.firstOrNull { !it.isArchived && it.isVisible && !it.isDeleted }?.id) }
    var selectedToAccountId by remember { mutableStateOf(accounts.firstOrNull { it.id != selectedFromAccountId && !it.isArchived && it.isVisible && !it.isDeleted }?.id) }

    LaunchedEffect(activeAccountId) {
        if (activeAccountId != null && selectedAccountId != activeAccountId) {
            selectedAccountId = activeAccountId
            selectedFromAccountId = activeAccountId
        }
    }
    var subcategory by remember { mutableStateOf("") }
    var categorySearchText by remember { mutableStateOf("") }

    var categoryMenuOpen by remember { mutableStateOf(false) }
    val catInteractionSource = remember { MutableInteractionSource() }
    val isCatFocused by catInteractionSource.collectIsFocusedAsState()

    var merchantSuggestionsExpanded by remember { mutableStateOf(false) }
    val merchantInteractionSource = remember { MutableInteractionSource() }
    val isMerchantFocused by merchantInteractionSource.collectIsFocusedAsState()

    var showDatePicker by remember { mutableStateOf(false) }
    var activeAmountTarget by remember { mutableStateOf(TxAmountTarget.NONE) }
    val datePickerState = rememberDatePickerState()
    var showEmojiInput by remember { mutableStateOf(false) }
    var showWebSearch by remember { mutableStateOf(false) }

    var isRealTransaction by remember { mutableStateOf(true) }
    var isHiddenTransaction by remember { mutableStateOf(false) }
    var isVaporizedTransaction by remember { mutableStateOf(false) }

    val dynamicMerchantSuggestions = remember(latest, categories) {
        val userMerchants = latest
            .filter { !it.isDeleted && !it.merchantKey.isNullOrBlank() }
            .sortedByDescending { it.createdAtEpochMs }
            .mapNotNull { tx ->
                val cleanName = stripSystemMarker(tx.merchantKey)?.trim()
                if (cleanName.isNullOrBlank()) return@mapNotNull null

                val catName = categories.firstOrNull { it.id == tx.categoryId }?.name ?: ""
                val fallback = detectSmartMerchant(cleanName)
                val finalEmoji = tx.logoEmoji?.takeIf { it.isNotBlank() } ?: fallback?.emoji

                val finalUri = tx.logoUri?.takeIf { it.isNotBlank() }
                    ?: fallback?.customUrl
                    ?: fallback?.domain?.let { "https://icon.horse/icon/$it" }
                    ?: if (finalEmoji.isNullOrBlank()) autoFaviconUrlForName(cleanName) else null

                PredefMerchant(
                    name = cleanName,
                    suggestedCategory = catName,
                    suggestedSubcategory = tx.subcategoryText ?: "",
                    domain = null,
                    emoji = finalEmoji,
                    customUrl = finalUri
                )
            }

        (userMerchants + defaultMerchantSuggestions)
            .filter { stripSystemMarker(it.name)?.isNotBlank() == true }
            .distinctBy { it.name.uppercase().trim() }
    }

    LaunchedEffect(initialBankData, dynamicMerchantSuggestions) {
        val rawMerchant = initialBankData?.merchant ?: BankNotificationCatcher.currentNotification?.merchant

        if (rawMerchant != null) {
            val rawLower = rawMerchant.lowercase()

            val bestMatch = dynamicMerchantSuggestions.firstOrNull { known ->
                val knownLower = known.name.lowercase()
                Regex("\\b${Regex.escape(knownLower)}\\b").containsMatchIn(rawLower)
            }

            val finalMerchant = bestMatch?.name ?: rawMerchant

            if (merchant == rawMerchant || merchant.isBlank()) {
                merchant = finalMerchant
            }

            if (initialBankData != null) {
                amountText = initialBankData.amount
                onBankDataConsumed()
            }
        }
    }

    LaunchedEffect(isCatFocused) {
        if (isCatFocused) {
            if (categorySearchText == "NESSUNA CATEGORIA") categorySearchText = ""
            categoryMenuOpen = true
        }
    }

    LaunchedEffect(merchant) {
        if (!manualLogoSet) {
            val exactMerchant = merchant.trim().lowercase()
            if (exactMerchant.length >= 2) {
                val match = dynamicMerchantSuggestions.firstOrNull { it.name.lowercase() == exactMerchant }
                if (match != null) {
                    logoUri = match.url
                    logoEmoji = match.emoji ?: ""
                    if (categorySearchText.isBlank()) categorySearchText = match.suggestedCategory
                    if (subcategory.isBlank()) subcategory = match.suggestedSubcategory
                } else {
                    logoUri = null
                    logoEmoji = ""
                }
            } else {
                logoUri = null
                logoEmoji = ""
            }
        }
    }

    val mediaHandler = rememberMediaHandler(
        onImageResult = { uri ->
            if (uri != null) {
                if (isImageActionForOCR) {
                    isImageActionForOCR = false
                    scope.launch {
                        isScanningReceipt = true
                        receiptError = false
                        try {
                            val data = receiptScanner.scanImage(uri.toString())
                            var foundData = false

                            if (data.total != null) {
                                amountText = data.total
                                foundData = true
                            }
                            if (data.merchant != null && merchant.isBlank()) {
                                merchant = data.merchant
                                merchantSuggestionsExpanded = true
                                foundData = true
                            }
                            if (data.date != null) {
                                dateTFV = TextFieldValue(data.date, TextRange(data.date.length))
                                foundData = true
                            }

                            if (!foundData) {
                                receiptError = true
                                desc = "ERRORE LETTURA:\n${data.rawText ?: "Nessun testo rilevato."}"
                            }
                        } catch(e: Exception) {
                            receiptError = true
                            desc = "ERRORE CRITICO: ${e.message}"
                        } finally {
                            isScanningReceipt = false
                        }
                    }
                } else {
                    logoUri = uri.toString()
                    logoEmoji = ""
                    manualLogoSet = true
                }
            } else {
                isImageActionForOCR = false
            }
        },
        onVoiceResult = { spokenText ->
            if (!spokenText.isNullOrBlank()) {
                val lowerSpoken = spokenText.lowercase()

                val regexAmount = Regex("""\b\d+(?:[.,]\d{1,2})?\b""")
                regexAmount.find(lowerSpoken)?.let {
                    amountText = it.value.replace(",", ".")
                }

                val merchantPreps = listOf(" da ", " dal ", " all'", " al ", " alla ", " allo ", " a ")
                var foundMerchant = ""
                for (prep in merchantPreps) {
                    if (lowerSpoken.contains(prep)) {
                        val parts = spokenText.split(Regex(prep, RegexOption.IGNORE_CASE))
                        if (parts.size > 1) {
                            foundMerchant = parts[1].split(" ").firstOrNull()?.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() } ?: ""
                            merchant = foundMerchant
                            break
                        }
                    }
                }

                val itemPreps = listOf(" per il ", " per la ", " per ", " di ")
                var foundItem = ""
                for (prep in itemPreps) {
                    if (lowerSpoken.contains(prep)) {
                        val parts = spokenText.split(Regex(prep, RegexOption.IGNORE_CASE))
                        if (parts.size > 1) {
                            foundItem = parts[1].trim()
                            if (foundMerchant.isNotBlank()) {
                                foundItem = foundItem.replace(foundMerchant, "", ignoreCase = true).trim()
                            }
                            break
                        }
                    }
                }

                if (foundItem.isNotBlank()) {
                    var matchedCategory = ""
                    for ((cat, keywords) in semanticCategories) {
                        if (keywords.any { foundItem.lowercase().contains(it) }) {
                            matchedCategory = cat
                            break
                        }
                    }

                    if (matchedCategory.isNotBlank()) {
                        categorySearchText = matchedCategory
                        if (matchedCategory == "Carburante") {
                            subcategory = foundItem.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
                        } else {
                            desc = foundItem.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
                        }
                    } else {
                        desc = foundItem.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
                    }
                }

                if (desc.isBlank() && foundItem.isBlank()) {
                    desc = spokenText.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
                }
            }
        }
    )

    val canSave = remember(amountText, isTransfer, selectedAccountId, selectedFromAccountId, selectedToAccountId, isRealTransaction) {
        val amtOk = parseEuroToCentsSafe(amountText) > 0L
        if (!isRealTransaction) return@remember amtOk
        if (isTransfer) amtOk && !selectedFromAccountId.isNullOrBlank() && !selectedToAccountId.isNullOrBlank() && selectedFromAccountId != selectedToAccountId
        else amtOk && !selectedAccountId.isNullOrBlank()
    }

    val previewLogoEmoji = if (isTransfer) accounts.find { it.id == selectedToAccountId }?.logoEmoji else logoEmoji.takeIf { it.isNotBlank() }
    val previewLogoUri = if (isTransfer) accounts.find { it.id == selectedToAccountId }?.logoUri else logoUri.takeIf { it?.isNotBlank() == true }

    // 🚀 LA NUOVA FUNZIONE DI SALVATAGGIO UNIVERSALE (Con ID Linkati)
    val performSaveTransaction: (Boolean, Long) -> Unit = { useEmergency, deficitToCover ->
        scope.launch {
            val timeNowMs = Clock.System.now().toEpochMilliseconds()
            val finalAmount = parseEuroToCentsSafe(amountText)
            val txEpochDay = parseDayMonthYearSafe(dateTFV.text) ?: today.toEpochDays().toLong()

            // 🚀 IL SEGRETO È QUI: Creiamo l'ID principale una sola volta e lo usiamo per tutti i figli!
            val mainTxId = "tx_${timeNowMs}_${Random.nextInt(1000)}"

            var finalCategoryId: String? = null
            val catTextClean = categorySearchText.trim().uppercase()
            if (catTextClean.isNotEmpty() && catTextClean != "NESSUNA CATEGORIA") {
                val existing = categories.firstOrNull { !it.isDeleted && it.name.equals(catTextClean, ignoreCase = true) }
                if (existing != null) { finalCategoryId = existing.id }
                else {
                    val norm = catTextClean.lowercase().replace("\\s+".toRegex(), "_").replace("[^a-z0-9_]+".toRegex(), "")
                    val newId = "cat_$norm"
                    val newCat = CategoryEntity(newId, catTextClean, false, timeNowMs, timeNowMs)
                    db.categoryQueries.upsert(newId, catTextClean, false, timeNowMs, timeNowMs)
                    try { viewModel.firestore.salva("categorie", newId, newCat) } catch(e: Exception){}
                    finalCategoryId = newId
                }
            }

            val finalAccountId = if (isCashMode) "sys_cash_generic" else if (isRealTransaction) selectedAccountId else "sys_ghost_$selectedAccountId"
            val finalFromId = if (isRealTransaction) selectedFromAccountId else "sys_ghost_$selectedFromAccountId"
            val finalToId = if (isRealTransaction) selectedToAccountId else "sys_ghost_$selectedToAccountId"

            // 🚀 INTERVENTO SCUDO: AUTO-RICARICA
            if (isIncome && isRealTransaction && !isVaporizedTransaction && finalAccountId != null) {
                val deficitTarget = emergencyTargetCents - emergencyBalanceCents
                if (deficitTarget > 0L) {
                    val refillAmount = minOf(finalAmount, deficitTarget)
                    val refillTx = TransactionEntity(
                        id = "tx_refill_$mainTxId", // 🚀 LINKATO!
                        accountId = finalAccountId, toAccountId = "sys_emergency_fund", fromAccountId = finalAccountId, amountCents = refillAmount, type = "TRANSFER", dateEpochDay = txEpochDay, categoryId = "default",
                        description = "Ricarica automatica Scudo", merchantKey = "Fondo di Emergenza", subcategoryText = "Auto-Ricarica", logoEmoji = "🛡️", logoUri = null, isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = timeNowMs - 5, updatedAtEpochMs = timeNowMs - 5
                    )
                    onSaveTx(refillTx)
                }
            }

            // 🚀 INTERVENTO SCUDO: AUTO-PRELIEVO
            if (useEmergency && deficitToCover > 0L && isRealTransaction && !isVaporizedTransaction && finalAccountId != null) {
                val drainTx = TransactionEntity(
                    id = "tx_drain_$mainTxId", // 🚀 LINKATO!
                    accountId = finalAccountId, toAccountId = finalAccountId, fromAccountId = "sys_emergency_fund", amountCents = deficitToCover, type = "TRANSFER", dateEpochDay = txEpochDay, categoryId = "default",
                    description = "Copertura spesa", merchantKey = "Fondo di Emergenza", subcategoryText = "Intervento Scudo", logoEmoji = "🛡️", logoUri = null, isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = timeNowMs - 5, updatedAtEpochMs = timeNowMs - 5
                )
                onSaveTx(drainTx)
            }

            pendingCashTxs.forEachIndexed { index, pcTx ->
                val subTx = TransactionEntity(
                    id = "tx_cash_${index}_$mainTxId", // 🚀 LINKATO!
                    accountId = "sys_ghost_cash", toAccountId = null, fromAccountId = null, amountCents = pcTx.amountCents, type = TYPE_EXPENSE, dateEpochDay = txEpochDay, categoryId = pcTx.categoryId ?: "default",
                    description = "Spesa in contanti associata [cash:$mainTxId]", merchantKey = pcTx.merchant, subcategoryText = "Contanti", logoEmoji = "💵", logoUri = "", isHidden = isHiddenTransaction, isDeleted = false, reminderDays = null, createdAtEpochMs = timeNowMs + 10 + index, updatedAtEpochMs = timeNowMs + 10 + index
                )
                onSaveTx(subTx)
            }

            if (isIncome && isSavingsActive && !selectedAccountId.isNullOrBlank()) {
                val pct = percentageText.toFloatOrNull() ?: 0f
                val amountToSave = (finalAmount * (pct / 100f)).toLong()
                if (amountToSave > 0L) {
                    val activePiggyBanks = piggyBanks.filter { !it.isDeleted }
                    if (activePiggyBanks.isNotEmpty()) {
                        val targetBank = activePiggyBanks.first()
                        val savingsCat = categories.firstOrNull { it.name.contains("Risparmi", ignoreCase = true) }?.id ?: "cat_savings_auto"

                        val sweepTx = TransactionEntity(
                            id = "tx_save_$mainTxId", // 🚀 LINKATO!
                            accountId = selectedAccountId, toAccountId = null, fromAccountId = null, amountCents = amountToSave, type = "EXPENSE", dateEpochDay = txEpochDay, categoryId = savingsCat,
                            description = "Accantonamento: ${pct.toInt()}%" + (if (pct == 100f) " (TUTTO)" else "") + " [pb:${targetBank.id}][p:$mainTxId]", merchantKey = "Salvadanaio: ${targetBank.name}", subcategoryText = "Risparmio Manuale", logoEmoji = targetBank.emoji.takeIf { it.isNotBlank() } ?: "🪙", logoUri = targetBank.imageUri ?: "", isHidden = isHiddenTransaction, isDeleted = false, reminderDays = null, createdAtEpochMs = timeNowMs + 100, updatedAtEpochMs = timeNowMs + 100
                        )
                        onSaveTx(sweepTx)

                        val updatedBank = targetBank.copy(accumulatedCents = targetBank.accumulatedCents + amountToSave, updatedAtEpochMs = timeNowMs + 100)
                        db.piggyBankQueries.upsert(updatedBank.id, updatedBank.name, updatedBank.accumulatedCents, updatedBank.emoji, updatedBank.colorHex, updatedBank.imageUri, updatedBank.isDeleted, updatedBank.createdAtEpochMs, updatedBank.updatedAtEpochMs)
                        try { viewModel.firestore.salva("salvadanai", updatedBank.id, updatedBank) } catch(e: Exception) {}
                    }
                }
            }

            var safeUri = logoUri.takeIf { it?.isNotBlank() == true }
            var safeEmoji = logoEmoji.takeIf { it.isNotBlank() }

            val feeCents = parseEuroToCentsSafe(feeText)
            if (feeCents > 0L && !isTransfer) {
                val feeTx = TransactionEntity(
                    id = "fee_$mainTxId", // 🚀 LINKATO!
                    type = TYPE_EXPENSE, accountId = finalAccountId, fromAccountId = null, toAccountId = null, amountCents = feeCents, dateEpochDay = txEpochDay, categoryId = finalCategoryId ?: "default",
                    description = "Commissione: ${normalizeTextSafe(merchant)}".trim(), merchantKey = "Commissioni ${normalizeTextSafe(merchant)}".trim(), logoEmoji = safeEmoji, logoUri = safeUri, subcategoryText = "Commissioni", isHidden = isHiddenTransaction, isDeleted = false, reminderDays = null, createdAtEpochMs = timeNowMs + 10, updatedAtEpochMs = timeNowMs + 10
                )
                onSaveTx(feeTx)
            }

            val mainTx = if (isVaporizedTransaction) {
                TransactionEntity(
                    id = mainTxId, accountId = if (isTransfer) null else finalAccountId, toAccountId = if (isTransfer) finalToId else null, fromAccountId = if (isTransfer) finalFromId else null, amountCents = finalAmount, type = mode, dateEpochDay = txEpochDay, categoryId = "sys_vaporized",
                    description = "Allineamento di sistema", merchantKey = "Conguaglio", subcategoryText = "Vaporizzato", logoEmoji = "💨", logoUri = null, isHidden = true, isDeleted = false, reminderDays = if (txEpochDay <= today.toEpochDays().toLong()) 0L else reminderDays, createdAtEpochMs = timeNowMs, updatedAtEpochMs = timeNowMs,
                )
            } else if (isCashMode) {
                TransactionEntity(
                    id = mainTxId,
                    accountId = "sys_cash_generic",
                    toAccountId = null,
                    fromAccountId = null,
                    amountCents = finalAmount,
                    type = if (cashModeIsExpense) "EXPENSE" else "INCOME",
                    dateEpochDay = txEpochDay,
                    categoryId = "default",
                    description = "Contanti liberi [cash:generic]",
                    merchantKey = merchant.trim().ifBlank { "Contanti" },
                    subcategoryText = "Gestione Cash",
                    logoEmoji = safeEmoji ?: "💶",
                    logoUri = safeUri,
                    isHidden = false,
                    isDeleted = false,
                    reminderDays = null,
                    createdAtEpochMs = timeNowMs,
                    updatedAtEpochMs = timeNowMs,
                )
            } else {
                TransactionEntity(
                    id = mainTxId, accountId = if (isTransfer) null else finalAccountId, toAccountId = if (isTransfer) finalToId else null, fromAccountId = if (isTransfer) finalFromId else null, amountCents = finalAmount, type = mode, dateEpochDay = txEpochDay, categoryId = finalCategoryId ?: "default",
                    description = desc.ifBlank { "" }, merchantKey = if (isTransfer) "Trasferimento" else merchant.takeIf { it.isNotBlank() }, subcategoryText = subcategory.takeIf { it.isNotBlank() }, logoEmoji = safeEmoji, logoUri = safeUri, isHidden = isHiddenTransaction, isDeleted = false, reminderDays = if (txEpochDay <= today.toEpochDays().toLong()) 0L else reminderDays, createdAtEpochMs = timeNowMs, updatedAtEpochMs = timeNowMs,
                )
            }

            onSaveTx(mainTx)
            onDismiss()
        }
    }

    val pickerThemeColor = remember(mode) {
        when (mode) {
            "INCOME" -> Color(0xFF059669)
            "TRANSFER" -> Color(0xFF0284C7)
            else -> Color(0xFFDC2626)
        }
    }

    val bgGradient = remember(mode) {
        val colors = when (mode) {
            "INCOME" -> listOf(
                Color(0xFF059669).copy(alpha = 0.75f),
                Color(0xFF064E3B),
                Color(0xFF0F172A)
            )
            "TRANSFER" -> listOf(
                Color(0xFF0284C7).copy(alpha = 0.75f),
                Color(0xFF0C4A6E),
                Color(0xFF0F172A)
            )
            else -> listOf( // EXPENSE
                Color(0xFFDC2626).copy(alpha = 0.75f),
                Color(0xFF7F1D1D),
                Color(0xFF0F172A)
            )
        }
        Brush.verticalGradient(colors = colors)
    }

    val isInnerPopupOpen = showPendingCashPopup || showWebSearch || showDatePicker || activeAmountTarget != TxAmountTarget.NONE || showSaldoWarning || showCashWarning || showCashExceededWarning || showSmartEmergencyWarning || showDuplicateWarning != null

    val dialogBlur by animateDpAsState(
        targetValue = if (isInnerPopupOpen) 12.dp else 0.dp,
        animationSpec = tween(durationMillis = 300),
        label = "dialogBlur"
    )

    Dialog(
        onDismissRequest = {
            onDismiss()
        },
        properties = DialogProperties(
            usePlatformDefaultWidth = false,
            dismissOnClickOutside = true,
            dismissOnBackPress = true
        )
    ) {
        Surface(
            modifier = Modifier.fillMaxSize(),
            color = Color.Transparent
        ) {
            Box(modifier = Modifier.fillMaxSize().background(bgGradient).blur(dialogBlur)) {
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .systemBarsPadding()
                        .imePadding()
                        .clickable(
                            interactionSource = remember { MutableInteractionSource() },
                            indication = null,
                            onClick = { categoryMenuOpen = false; merchantSuggestionsExpanded = false }
                        )
                ) {
                    if (isScanningReceipt) {
                        LinearProgressIndicator(modifier = Modifier.fillMaxWidth().height(4.dp), color = Color.White)
                    }

                    // HEADER FISSO IN ALTO
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 8.dp, vertical = 8.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        IconButton(onClick = onDismiss) {
                            Icon(Icons.Default.ArrowBack, contentDescription = "Indietro", tint = Color.White)
                        }
                    }

                    Text(
                        text = if (isCashMode) "Nuovo Movimento Contanti" else if (isTransfer) "Nuovo Trasferimento" else if (isIncome) "Nuova Entrata" else "Nuova Uscita",
                        style = MaterialTheme.typography.headlineMedium.copy(fontWeight = FontWeight.Bold),
                        color = if (isCashMode) Color(0xFF10B981) else Color.White,
                        modifier = Modifier.padding(start = 24.dp, end = 24.dp, bottom = 16.dp)
                    )

                    AnimatedVisibility(visible = receiptError) {
                        Text(
                            text = "Scontrino non riconosciuto o illeggibile. Riprova.",
                            color = MaterialTheme.colorScheme.error,
                            style = MaterialTheme.typography.labelMedium,
                            modifier = Modifier.padding(start = 24.dp, end = 24.dp, bottom = 16.dp)
                        )
                    }

                    // CORPO SCORREVOLE CENTRALE
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .weight(1f)
                            .verticalScroll(rememberScrollState())
                            .padding(horizontal = 24.dp),
                        verticalArrangement = Arrangement.spacedBy(20.dp)
                    ) {

                        if (isCashMode) {
                            Text(
                                "Questo movimento modificherà solo il totale dei contanti in tasca.",
                                style = MaterialTheme.typography.bodySmall,
                                color = Color(0xFFA0A0A0)
                            )
                            Row(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(14.dp)).background(Color.White.copy(alpha = 0.10f))) {
                                Surface(
                                    onClick = { cashModeIsExpense = true },
                                    shape = RoundedCornerShape(14.dp),
                                    color = if (cashModeIsExpense) MaterialTheme.colorScheme.error.copy(alpha = 0.25f) else Color.Transparent,
                                    modifier = Modifier.weight(1f).height(44.dp)
                                ) { Box(contentAlignment = Alignment.Center) { Text("Spesa (-)", color = if(cashModeIsExpense) MaterialTheme.colorScheme.error else Color(0xFFA0A0A0), fontWeight = FontWeight.Bold) } }

                                Surface(
                                    onClick = { cashModeIsExpense = false },
                                    shape = RoundedCornerShape(14.dp),
                                    color = if (!cashModeIsExpense) Color(0xFF10B981).copy(alpha = 0.25f) else Color.Transparent,
                                    modifier = Modifier.weight(1f).height(44.dp)
                                ) { Box(contentAlignment = Alignment.Center) { Text("Entrata (+)", color = if(!cashModeIsExpense) Color(0xFF10B981) else Color(0xFFA0A0A0), fontWeight = FontWeight.Bold) } }
                            }
                        }

                        Column {
                            StableWebNumberField(
                                value = amountText,
                                onValueChange = { amountText = it },
                                label = "IMPORTO (€)",
                                interactionSource = amountInteractionSource,
                                trailingIcon = {
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        IconButton(onClick = { activeAmountTarget = TxAmountTarget.AMOUNT }) { Icon(Icons.Default.MoreVert, null, tint = Color.White) }
                                        IconButton(onClick = { mediaHandler.startVoiceRecognition() }) { Icon(Icons.Outlined.Mic, null, tint = Color.White) }
                                    }
                                }
                            )

                            Spacer(Modifier.height(8.dp))
                            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceEvenly) {
                                OutlinedButton(
                                    onClick = { isImageActionForOCR = true; receiptError = false; mediaHandler.launchCamera() },
                                    modifier = Modifier.weight(1f).height(40.dp),
                                    shape = RoundedCornerShape(14.dp),
                                    colors = ButtonDefaults.outlinedButtonColors(containerColor = Color.White.copy(alpha = 0.10f), contentColor = Color.White),
                                    border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f))
                                ) {
                                    Icon(Icons.Outlined.CameraAlt, contentDescription = null, modifier = Modifier.size(16.dp), tint = Color.White)
                                    Spacer(Modifier.width(6.dp))
                                    Text("Scatta OCR", style = MaterialTheme.typography.labelMedium, color = Color.White)
                                }
                                Spacer(Modifier.width(8.dp))
                                OutlinedButton(
                                    onClick = { isImageActionForOCR = true; receiptError = false; mediaHandler.launchGallery() },
                                    modifier = Modifier.weight(1f).height(40.dp),
                                    shape = RoundedCornerShape(14.dp),
                                    colors = ButtonDefaults.outlinedButtonColors(containerColor = Color.White.copy(alpha = 0.10f), contentColor = Color.White),
                                    border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f))
                                ) {
                                    Icon(Icons.Outlined.Search, contentDescription = null, modifier = Modifier.size(16.dp), tint = Color.White)
                                    Spacer(Modifier.width(6.dp))
                                    Text("Scontrino", style = MaterialTheme.typography.labelMedium, color = Color.White)
                                }
                            }
                        }

                        // 🚀 SEZIONE RISPARMIO CON TAB RAPIDI E ANTEPRIMA IMPORTO LIVE
                        if (isIncome) {
                            Column(modifier = Modifier.fillMaxWidth().padding(vertical = 10.dp)) {
                                Row(
                                    verticalAlignment = Alignment.CenterVertically,
                                    modifier = Modifier.fillMaxWidth().clickable { isSavingsActive = !isSavingsActive }
                                ) {
                                    MonetixGlassSwitch(
                                        checked = isSavingsActive,
                                        onCheckedChange = { isSavingsActive = it },
                                        activeColor = pickerThemeColor
                                    )
                                    Spacer(Modifier.width(12.dp))
                                    Text("Metti da parte nel salvadanaio", style = MaterialTheme.typography.bodyMedium, color = Color.White)
                                }

                                AnimatedVisibility(visible = isSavingsActive) {
                                    Column(modifier = Modifier.fillMaxWidth().padding(top = 12.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {

                                        val totalCents = remember(amountText) { parseEuroToCentsSafe(amountText) }
                                        val currentPct = percentageText.toFloatOrNull() ?: 0f
                                        val previewCents = (totalCents.toFloat() * (currentPct / 100f)).toLong()
                                        val previewString = formatEuroFromCents(previewCents)

                                        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                            listOf("10%", "25%", "50%", "100%").forEach { tabLabel ->
                                                val tabValue = tabLabel.replace("%", "")
                                                val isSelected = percentageText == tabValue
                                                FilterChip(
                                                    selected = isSelected,
                                                    onClick = { percentageText = tabValue },
                                                    label = {
                                                        Text(
                                                            text = tabLabel,
                                                            fontWeight = FontWeight.Bold,
                                                            color = Color.White
                                                        )
                                                    },
                                                    shape = RoundedCornerShape(16.dp),
                                                    colors = FilterChipDefaults.filterChipColors(
                                                        selectedContainerColor = Color.White.copy(alpha = 0.25f),
                                                        selectedLabelColor = Color.White,
                                                        containerColor = Color.White.copy(alpha = 0.08f),
                                                        labelColor = Color(0xFFA0A0A0)
                                                    ),
                                                    border = FilterChipDefaults.filterChipBorder(
                                                        enabled = true,
                                                        selected = isSelected,
                                                        borderColor = Color.White.copy(alpha = 0.15f),
                                                        selectedBorderColor = Color.White.copy(alpha = 0.4f)
                                                    )
                                                )
                                            }
                                        }

                                        OutlinedTextField(
                                            value = percentageText,
                                            onValueChange = { newVal ->
                                                if (newVal.all { it.isDigit() }) {
                                                    val num = newVal.toIntOrNull() ?: 0
                                                    if (num <= 100) percentageText = newVal
                                                }
                                            },
                                            label = { Text("Percentuale manuale (0-100)") },
                                            trailingIcon = { Text("%", fontWeight = FontWeight.ExtraBold, color = Color.White, modifier = Modifier.padding(end = 8.dp)) },
                                            supportingText = {
                                                if (previewCents > 0L) {
                                                    Text(
                                                        text = "Metterai da parte: $previewString",
                                                        fontWeight = FontWeight.Bold,
                                                        color = Color.White
                                                    )
                                                }
                                            },
                                            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                                            interactionSource = savingsInteractionSource,
                                            modifier = Modifier.fillMaxWidth(),
                                            shape = RoundedCornerShape(14.dp),
                                            colors = OutlinedTextFieldDefaults.colors(
                                                focusedTextColor = Color.White,
                                                unfocusedTextColor = Color.White,
                                                focusedContainerColor = Color.White.copy(alpha = 0.10f),
                                                unfocusedContainerColor = Color.White.copy(alpha = 0.05f),
                                                focusedBorderColor = Color.White.copy(alpha = 0.35f),
                                                unfocusedBorderColor = Color.White.copy(alpha = 0.15f),
                                                focusedLabelColor = Color.White,
                                                unfocusedLabelColor = Color(0xFFA0A0A0)
                                            )
                                        )
                                    }
                                }
                            }
                            HorizontalDivider(color = MaterialTheme.colorScheme.outline.copy(alpha = 0.05f))
                        }

                        if (!isTransfer && !isCashMode) {
                            StableWebNumberField(
                                value = feeText,
                                onValueChange = { feeText = it },
                                label = "COMMISSIONI (€)",
                                interactionSource = feeInteractionSource,
                                leadingIcon = { Icon(Icons.Default.AddCircleOutline, null, tint = Color.White.copy(alpha = 0.5f)) },
                                trailingIcon = { IconButton(onClick = { activeAmountTarget = TxAmountTarget.FEE }) { Icon(Icons.Default.MoreVert, null, tint = Color.White) } }
                            )
                        }

                        if (!isCashMode) {
                            OutlinedTextField(
                                value = dateTFV, onValueChange = onDateTFVChange, label = { Text("DATA (GG/MM/AAAA)", style = MaterialTheme.typography.labelSmall) },
                                modifier = Modifier.fillMaxWidth(), interactionSource = dateInteractionSource, keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number), shape = RoundedCornerShape(14.dp),
                                trailingIcon = { IconButton(onClick = { showDatePicker = true }) { Icon(Icons.Default.CalendarMonth, null, tint = Color.White) } },
                                colors = OutlinedTextFieldDefaults.colors(
                                    focusedTextColor = Color.White,
                                    unfocusedTextColor = Color.White,
                                    focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                                    unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                                    focusedBorderColor = Color.White.copy(alpha = 0.40f),
                                    unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
                                    focusedLabelColor = Color.White,
                                    unfocusedLabelColor = Color(0xFFA0A0A0)
                                )
                            )

                            AnimatedVisibility(visible = isFutureDate) {
                                Column(modifier = Modifier.fillMaxWidth().padding(top = 8.dp)) {
                                    Text("Invia notifica promemoria:", style = MaterialTheme.typography.labelSmall, color = Color.White)
                                    Spacer(Modifier.height(8.dp))
                                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                                        listOf(0L to "No", 1L to "1 g. prima", 2L to "2 g. prima", 3L to "3 g. prima").forEach { (days, label) ->
                                            FilterChip(
                                                selected = reminderDays == days,
                                                onClick = { reminderDays = days },
                                                label = { Text(label, fontSize = 12.sp) },
                                                shape = RoundedCornerShape(16.dp)
                                            )
                                        }
                                    }
                                }
                            }
                        }

                        Surface(
                            modifier = Modifier.fillMaxWidth().padding(bottom = 12.dp, top = 8.dp),
                            shape = RoundedCornerShape(16.dp),
                            color = Color.Black.copy(alpha = 0.30f),
                            contentColor = Color.White,
                            border = BorderStroke(1.dp, Color.White.copy(alpha = 0.20f))
                        ) {
                            Column {
                                Row(modifier = Modifier.padding(12.dp), verticalAlignment = Alignment.CenterVertically) {
                                    MonetixGlassSwitch(checked = isRealTransaction, onCheckedChange = { isRealTransaction = it }, activeColor = pickerThemeColor)
                                    Spacer(Modifier.width(12.dp))
                                    Column {
                                        Text("Movimenta il conto", style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = Color.White)
                                        Text(
                                            text = if (isRealTransaction) "I soldi modificano il saldo reale" else "Solo promemoria (Es. Contanti)",
                                            style = MaterialTheme.typography.bodySmall,
                                            color = Color(0xFFA0A0A0)
                                        )
                                    }
                                }

                                HorizontalDivider(color = Color.White.copy(alpha = 0.10f))

                                Row(modifier = Modifier.padding(12.dp), verticalAlignment = Alignment.CenterVertically) {
                                    MonetixGlassSwitch(checked = isHiddenTransaction, onCheckedChange = { isHiddenTransaction = it }, activeColor = pickerThemeColor)
                                    Spacer(Modifier.width(12.dp))
                                    Column {
                                        Text("Nascondi Movimento", style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = Color.White)
                                        Text(
                                            text = if (isHiddenTransaction) "Escluso dai saldi e dalle statistiche" else "Visibile regolarmente nel conto",
                                            style = MaterialTheme.typography.bodySmall,
                                            color = Color(0xFFA0A0A0)
                                        )
                                    }
                                }

                                // 🚀 NUOVO TOGGLE: VAPORIZZA 💨
                                HorizontalDivider(color = Color.White.copy(alpha = 0.10f))
                                Row(modifier = Modifier.padding(12.dp), verticalAlignment = Alignment.CenterVertically) {
                                    MonetixGlassSwitch(
                                        checked = isVaporizedTransaction,
                                        onCheckedChange = {
                                            isVaporizedTransaction = it
                                            if (it) isHiddenTransaction = true
                                        },
                                        activeColor = MaterialTheme.colorScheme.error
                                    )
                                    Spacer(Modifier.width(12.dp))
                                    Column {
                                        Text("Vaporizza 💨", style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.error)
                                        Text(
                                            text = "Allineamento: corregge il saldo senza fare rumore",
                                            style = MaterialTheme.typography.bodySmall,
                                            color = Color(0xFFA0A0A0)
                                        )
                                    }
                                }
                            }
                        }

                        AnimatedVisibility(visible = isRealTransaction) {
                            if (!isTransfer) {
                                var accExpanded by remember { mutableStateOf(false) }
                                ExposedDropdownMenuBox(expanded = accExpanded, onExpandedChange = { accExpanded = !accExpanded }) {
                                    val current = accounts.firstOrNull { it.id == selectedAccountId }
                                    OutlinedTextField(
                                        value = current?.name?.let { stripSystemMarker(it) ?: it } ?: "",
                                        onValueChange = {}, readOnly = true, label = { Text("CONTO", style = MaterialTheme.typography.labelSmall) },
                                        trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(accExpanded) },
                                        modifier = Modifier.menuAnchor().fillMaxWidth(), shape = RoundedCornerShape(14.dp),
                                        colors = OutlinedTextFieldDefaults.colors(
                                            focusedTextColor = Color.White,
                                            unfocusedTextColor = Color.White,
                                            focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                                            unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                                            focusedBorderColor = Color.White.copy(alpha = 0.40f),
                                            unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
                                            focusedLabelColor = Color.White,
                                            unfocusedLabelColor = Color(0xFFA0A0A0)
                                        )
                                    )
                                    ExposedDropdownMenu(expanded = accExpanded, onDismissRequest = { accExpanded = false }, containerColor = Color(0xFF1C1C1E)) {
                                        accounts.filter { !it.isArchived && !it.isDeleted }.forEach { a -> DropdownMenuItem(text = { Text(stripSystemMarker(a.name) ?: a.name, color = Color.White) }, onClick = { selectedAccountId = a.id; accExpanded = false }) }
                                    }
                                }
                            } else {
                                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                                    var fExp by remember { mutableStateOf(false) }
                                    Box(modifier = Modifier.weight(1f)) {
                                        ExposedDropdownMenuBox(expanded = fExp, onExpandedChange = { fExp = !fExp }) {
                                            val cur = accounts.firstOrNull { it.id == selectedFromAccountId }
                                            OutlinedTextField(
                                                value = cur?.name?.let { stripSystemMarker(it) ?: it } ?: "",
                                                onValueChange = {}, readOnly = true, label = { Text("DA", style = MaterialTheme.typography.labelSmall) },
                                                modifier = Modifier.menuAnchor().fillMaxWidth(), shape = RoundedCornerShape(14.dp),
                                                colors = OutlinedTextFieldDefaults.colors(
                                                    focusedTextColor = Color.White,
                                                    unfocusedTextColor = Color.White,
                                                    focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                                                    unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                                                    focusedBorderColor = Color.White.copy(alpha = 0.40f),
                                                    unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
                                                    focusedLabelColor = Color.White,
                                                    unfocusedLabelColor = Color(0xFFA0A0A0)
                                                )
                                            )
                                            ExposedDropdownMenu(expanded = fExp, onDismissRequest = { fExp = false }, containerColor = Color(0xFF1C1C1E)) {
                                                accounts.filter { !it.isArchived && !it.isDeleted }.forEach { a -> DropdownMenuItem(text = { Text(stripSystemMarker(a.name) ?: a.name, color = Color.White) }, onClick = { selectedFromAccountId = a.id; fExp = false }) }
                                            }
                                        }
                                    }
                                    var tExp by remember { mutableStateOf(false) }
                                    Box(modifier = Modifier.weight(1f)) {
                                        ExposedDropdownMenuBox(expanded = tExp, onExpandedChange = { tExp = !tExp }) {
                                            val cur = accounts.firstOrNull { it.id == selectedToAccountId }
                                            OutlinedTextField(
                                                value = cur?.name?.let { stripSystemMarker(it) ?: it } ?: "",
                                                onValueChange = {}, readOnly = true, label = { Text("A", style = MaterialTheme.typography.labelSmall) },
                                                modifier = Modifier.menuAnchor().fillMaxWidth(), shape = RoundedCornerShape(14.dp),
                                                colors = OutlinedTextFieldDefaults.colors(
                                                    focusedTextColor = Color.White,
                                                    unfocusedTextColor = Color.White,
                                                    focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                                                    unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                                                    focusedBorderColor = Color.White.copy(alpha = 0.40f),
                                                    unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
                                                    focusedLabelColor = Color.White,
                                                    unfocusedLabelColor = Color(0xFFA0A0A0)
                                                )
                                            )
                                            ExposedDropdownMenu(expanded = tExp, onDismissRequest = { tExp = false }, containerColor = Color(0xFF1C1C1E)) {
                                                accounts.filter { !it.isArchived && !it.isDeleted && it.id != selectedFromAccountId }.forEach { a -> DropdownMenuItem(text = { Text(stripSystemMarker(a.name) ?: a.name, color = Color.White) }, onClick = { selectedToAccountId = a.id; tExp = false }) }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                            Text("LOGO E ICONA", style = MaterialTheme.typography.labelSmall, color = Color.White)
                            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                                TxLogo(
                                    logoEmoji = previewLogoEmoji,
                                    logoUri = previewLogoUri,
                                    name = merchant,
                                    modifier = Modifier.size(54.dp).border(1.dp, brandPrimary.copy(alpha = 0.1f), CircleShape)
                                )
                                if (!isTransfer) {
                                    FlowRow(modifier = Modifier.weight(1f), horizontalArrangement = Arrangement.spacedBy(6.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                                        OutlinedButton(onClick = { isImageActionForOCR = false; mediaHandler.launchGallery() }, shape = RoundedCornerShape(8.dp), contentPadding = PaddingValues(horizontal = 12.dp), modifier = Modifier.height(36.dp)) { Text("FOTO", style = MaterialTheme.typography.labelSmall, color = Color.White) }
                                        OutlinedButton(onClick = { showEmojiInput = !showEmojiInput; showWebSearch = false }, shape = RoundedCornerShape(8.dp), contentPadding = PaddingValues(horizontal = 12.dp), modifier = Modifier.height(36.dp)) { Text("EMOJI", style = MaterialTheme.typography.labelSmall, color = Color.White) }
                                        OutlinedButton(onClick = { showWebSearch = true; showEmojiInput = false }, shape = RoundedCornerShape(8.dp), contentPadding = PaddingValues(horizontal = 12.dp), modifier = Modifier.height(36.dp)) { Text("WEB", style = MaterialTheme.typography.labelSmall, color = Color.White) }
                                    }
                                }
                            }
                            AnimatedVisibility(visible = showEmojiInput) {
                                StableWebTextField(
                                    value = logoEmoji,
                                    onValueChange = { if (it.length <= 3) { logoEmoji = it; logoUri = null; manualLogoSet = true } },
                                    label = "Inserisci Emoji"
                                )
                            }
                        }

                        if (!isTransfer) {
                            Column(modifier = Modifier.fillMaxWidth()) {
                                Box(modifier = Modifier.fillMaxWidth()) {
                                    StableWebTextField(
                                        value = merchant,
                                        onValueChange = {
                                            merchant = it
                                            merchantSuggestionsExpanded = it.isNotBlank()
                                        },
                                        label = "ESERCENTE",
                                        interactionSource = merchantInteractionSource
                                    )

                                    val filteredMerchants = dynamicMerchantSuggestions.filter {
                                        it.name.contains(merchant, ignoreCase = true)
                                    }

                                    DropdownMenu(
                                        expanded = merchantSuggestionsExpanded && filteredMerchants.isNotEmpty() && isMerchantFocused,
                                        onDismissRequest = { merchantSuggestionsExpanded = false },
                                        properties = PopupProperties(focusable = false),
                                        modifier = Modifier.fillMaxWidth(0.8f).heightIn(max = 220.dp).background(Color(0xFF1C1C1E))
                                    ) {
                                        filteredMerchants.take(10).forEach { merch ->
                                            DropdownMenuItem(
                                                text = { Text(merch.name.cleanDisplayName(), fontWeight = FontWeight.SemiBold, color = Color.White) },
                                                leadingIcon = {
                                                    TxLogo(
                                                        logoEmoji = merch.emoji,
                                                        logoUri = merch.url,
                                                        name = merch.name.cleanDisplayName(),
                                                        modifier = Modifier.size(24.dp)
                                                    )
                                                },
                                                onClick = {
                                                    merchant = merch.name
                                                    if (categorySearchText.isBlank()) categorySearchText = merch.suggestedCategory
                                                    if (subcategory.isBlank()) subcategory = merch.suggestedSubcategory

                                                    logoUri = merch.url
                                                    logoEmoji = merch.emoji ?: ""
                                                    manualLogoSet = true

                                                    merchantSuggestionsExpanded = false
                                                }
                                            )
                                        }
                                    }
                                }

                                AnimatedVisibility(visible = merchant.isBlank()) {
                                    Column(modifier = Modifier.padding(top = 12.dp)) {
                                        Text("Esercenti frequenti:", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                        Spacer(Modifier.height(8.dp))
                                        LazyRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                            items(dynamicMerchantSuggestions.filter { it.name.cleanDisplayName().isNotBlank() }.take(15)) { merch ->
                                                FilterChip(
                                                    selected = false,
                                                    onClick = {
                                                        merchant = merch.name.cleanDisplayName()
                                                        if (categorySearchText.isBlank()) categorySearchText = merch.suggestedCategory
                                                        if (subcategory.isBlank()) subcategory = merch.suggestedSubcategory

                                                        logoUri = merch.url
                                                        logoEmoji = merch.emoji ?: ""
                                                        manualLogoSet = true
                                                    },
                                                    label = { Text(merch.name.cleanDisplayName(), style = MaterialTheme.typography.bodySmall, color = Color.White) },
                                                    leadingIcon = {
                                                        when {
                                                            merch.url != null -> AsyncImage(model = merch.url, contentDescription = null, modifier = Modifier.size(16.dp))
                                                            merch.emoji != null -> Text(merch.emoji, fontSize = 14.sp)
                                                        }
                                                    },
                                                    shape = RoundedCornerShape(16.dp)
                                                )
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        Box(modifier = Modifier.fillMaxWidth()) {
                            StableWebTextField(
                                value = categorySearchText,
                                onValueChange = {
                                    categorySearchText = it
                                    categoryMenuOpen = true
                                },
                                label = "CATEGORIA",
                                interactionSource = catInteractionSource,
                                trailingIcon = {
                                    IconButton(onClick = { categoryMenuOpen = !categoryMenuOpen }) {
                                        Icon(if (categoryMenuOpen) Icons.Default.KeyboardArrowUp else Icons.Default.KeyboardArrowDown, null)
                                    }
                                }
                            )

                            DropdownMenu(
                                expanded = categoryMenuOpen && isCatFocused,
                                onDismissRequest = { categoryMenuOpen = false },
                                properties = PopupProperties(focusable = false),
                                modifier = Modifier
                                    .fillMaxWidth(0.8f)
                                    .heightIn(max = 220.dp)
                                    .background(Color(0xFF1C1C1E))
                            ) {
                                DropdownMenuItem(
                                    text = { Text("Nessuna categoria", color = Color.White) },
                                    colors = MenuDefaults.itemColors(textColor = Color.White),
                                    onClick = { categorySearchText = ""; categoryMenuOpen = false }
                                )

                                val filtered = categories.filter { !it.isDeleted && it.name.contains(categorySearchText, ignoreCase = true) }

                                if (categorySearchText.isNotBlank() && filtered.none { it.name.equals(categorySearchText, ignoreCase = true) }) {
                                    DropdownMenuItem(
                                        text = { Text("+ Crea \"${categorySearchText.uppercase()}\"", color = Color(0xFF60A5FA), fontWeight = FontWeight.Bold) },
                                        colors = MenuDefaults.itemColors(textColor = Color(0xFF60A5FA)),
                                        onClick = {
                                            val catTextClean = categorySearchText.trim().uppercase()
                                            val norm = catTextClean.lowercase().replace("\\s+".toRegex(), "_").replace("[^a-z0-9_]+".toRegex(), "")
                                            val newId = "cat_$norm"
                                            val newCat = CategoryEntity(newId, catTextClean, false, Clock.System.now().toEpochMilliseconds(), Clock.System.now().toEpochMilliseconds())
                                            scope.launch {
                                                db.categoryQueries.upsert(id = newId, name = catTextClean, isDeleted = false, createdAtEpochMs = Clock.System.now().toEpochMilliseconds(), updatedAtEpochMs = Clock.System.now().toEpochMilliseconds())
                                                try { viewModel.firestore.salva("categorie", newId, newCat) } catch(e: Exception){}
                                            }
                                            categorySearchText = catTextClean
                                            categoryMenuOpen = false
                                        }
                                    )
                                }

                                filtered.forEach { cat ->
                                    DropdownMenuItem(
                                        text = { Text(cat.name, color = Color.White) },
                                        colors = MenuDefaults.itemColors(textColor = Color.White),
                                        trailingIcon = {
                                            IconButton(
                                                onClick = {
                                                    scope.launch(Dispatchers.Default) {
                                                        db.categoryQueries.upsert(cat.id, cat.name, true, cat.createdAtEpochMs, Clock.System.now().toEpochMilliseconds())
                                                        val deletedCat = cat.copy(isDeleted = true, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds())
                                                        try { viewModel.firestore.salva("categorie", cat.id, deletedCat) } catch(e: Exception){}
                                                    }
                                                    if (categorySearchText == cat.name) categorySearchText = ""
                                                }
                                            ) {
                                                Icon(Icons.Outlined.Delete, "Elimina", tint = MaterialTheme.colorScheme.error.copy(alpha = 0.6f))
                                            }
                                        },
                                        onClick = { categorySearchText = cat.name; categoryMenuOpen = false }
                                    )
                                }
                            }
                        }

                        if (!isTransfer) {
                            StableWebTextField(
                                value = subcategory,
                                onValueChange = { subcategory = it },
                                label = "SOTTO-CATEGORIA"
                            )

                            StableWebTextField(
                                value = desc,
                                onValueChange = { desc = it },
                                label = "NOTE"
                            )

                            val totalMainCents = parseEuroToCentsSafe(amountText)
                            val totalPendingCash = pendingCashTxs.sumOf { it.amountCents }
                            val remainingMainCash = totalMainCents - totalPendingCash
                            val cashProgress = if (totalMainCents > 0) (totalPendingCash.toFloat() / totalMainCents.toFloat()).coerceIn(0f, 1f) else 0f

                            Spacer(Modifier.height(16.dp))
                            Surface(
                                modifier = Modifier.fillMaxWidth().padding(top = 8.dp),
                                color = Color.White.copy(alpha = 0.08f),
                                contentColor = Color.White,
                                shape = RoundedCornerShape(16.dp),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                            ) {
                                Column(Modifier.padding(16.dp)) {
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        Icon(Icons.Default.AccountBalanceWallet, null, tint = Color.White, modifier = Modifier.size(20.dp))
                                        Spacer(Modifier.width(8.dp))
                                        Text("DETTAGLIO SPESE (DI CUI)", style = MaterialTheme.typography.labelSmall, color = Color.White, fontWeight = FontWeight.Bold)
                                    }
                                    Spacer(Modifier.height(12.dp))

                                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                                        Text("Totale 'Di cui': ${formatEuroFromCents(totalPendingCash)}", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                                        Text("Rimanenza: ${formatEuroFromCents(remainingMainCash)}", style = MaterialTheme.typography.bodySmall.copy(fontWeight = FontWeight.Bold), color = if (remainingMainCash >= 0) Color(0xFF10B981) else MaterialTheme.colorScheme.error)
                                    }
                                    Spacer(Modifier.height(6.dp))
                                    LinearProgressIndicator(progress = { cashProgress }, modifier = Modifier.fillMaxWidth().height(6.dp).clip(CircleShape), color = Color.White)

                                    if (pendingCashTxs.isNotEmpty()) {
                                        Spacer(Modifier.height(12.dp))
                                        Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                                            pendingCashTxs.forEach { pcTx ->
                                                Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.SpaceBetween) {
                                                    Column(modifier = Modifier.weight(1f)) {
                                                        Text(pcTx.merchant, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold), maxLines = 1, overflow = TextOverflow.Ellipsis)
                                                        Text(pcTx.categoryName, style = MaterialTheme.typography.labelSmall, color = Color.LightGray)
                                                    }
                                                    Text(formatEuroFromCents(pcTx.amountCents), style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold))
                                                    IconButton(onClick = { pendingCashTxs.remove(pcTx) }, modifier = Modifier.size(24.dp)) {
                                                        Icon(Icons.Outlined.Delete, null, tint = MaterialTheme.colorScheme.error, modifier = Modifier.size(16.dp))
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    Spacer(Modifier.height(16.dp))
                                    OutlinedButton(
                                        onClick = { showPendingCashPopup = true },
                                        modifier = Modifier.fillMaxWidth().height(36.dp),
                                        shape = RoundedCornerShape(14.dp),
                                        colors = ButtonDefaults.outlinedButtonColors(containerColor = Color.White.copy(alpha = 0.10f), contentColor = Color.White),
                                        border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f))
                                    ) {
                                        Icon(Icons.Default.Add, null, modifier = Modifier.size(16.dp), tint = Color.White)
                                        Spacer(Modifier.width(8.dp))
                                        Text("+ Aggiungi Sotto-Spesa", style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                                    }
                                }
                            }

                        } else {
                            StableWebTextField(value = desc, onValueChange = { desc = it }, label = "NOTE TRASFERIMENTO")
                        }
                        
                        Spacer(Modifier.height(140.dp)) // padding for FAB
                    } // Fine corpo scorrevole
                }

                val haptic = LocalHapticFeedback.current
                FloatingActionButton(
                    onClick = {
                        if (!canSave) return@FloatingActionButton
                        val finalAmount = parseEuroToCentsSafe(amountText)
                        val saldoCorrente = saldoDisponibile

                        if (mode == TYPE_EXPENSE && finalAmount > saldoCorrente && !isVaporizedTransaction) {
                            val deficit = finalAmount - saldoCorrente
                            if (emergencyBalanceCents >= deficit) {
                                haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                pendingEmergencyDeficit = deficit
                                showSmartEmergencyWarning = true
                                return@FloatingActionButton
                            } else {
                                haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                showSaldoWarning = true
                                return@FloatingActionButton
                            }
                        }

                        val totalPendingCash = pendingCashTxs.sumOf { it.amountCents }
                        if (totalPendingCash > finalAmount) {
                            haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                            showCashWarning = true
                            return@FloatingActionButton
                        }

                        val txEpochDay = parseDayMonthYearSafe(dateTFV.text) ?: today.toEpochDays().toLong()

                        if (!isTransfer && !isVaporizedTransaction) {
                            val doppione = latest.firstOrNull { tx ->
                                !tx.isDeleted &&
                                        tx.type == mode &&
                                        tx.dateEpochDay == txEpochDay &&
                                        tx.amountCents == finalAmount &&
                                        tx.merchantKey?.trim()?.equals(merchant.trim(), ignoreCase = true) == true
                            }

                            if (doppione != null) {
                                haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                pendingEmergencyDeficit = 0L
                                showDuplicateWarning = doppione
                                return@FloatingActionButton
                            }
                        }

                        performSaveTransaction(false, 0L)
                    },
                    containerColor = if (canSave) pickerThemeColor else Color.White.copy(alpha = 0.12f),
                    contentColor = if (canSave) Color.White else Color(0xFFA0A0A0),
                    modifier = Modifier
                        .align(Alignment.BottomEnd)
                        .padding(end = 24.dp, bottom = 64.dp)
                ) {
                    Icon(Icons.Default.ArrowDownward, contentDescription = "Salva", tint = if (canSave) Color.White else Color(0xFFA0A0A0))
                }
            }
        }

        if (activeAmountTarget != TxAmountTarget.NONE) {
            val initialText = if (activeAmountTarget == TxAmountTarget.AMOUNT) amountText else feeText
            val parsedInitial = initialText.replace(',', '.').toDoubleOrNull() ?: 0.0
            var tempEuro by remember { mutableStateOf(kotlin.math.floor(parsedInitial).toInt().coerceIn(0, 5000)) }
            var tempCent by remember { mutableStateOf(((parsedInitial - kotlin.math.floor(parsedInitial)) * 100).roundToInt().coerceIn(0, 99)) }

            AlertDialog(
                onDismissRequest = { activeAmountTarget = TxAmountTarget.NONE },
                shape = RoundedCornerShape(28.dp),
                containerColor = Color.White.copy(alpha = 0.12f),
                title = { Text(if (activeAmountTarget == TxAmountTarget.AMOUNT) "Importo Operazione" else "Commissioni", fontWeight = FontWeight.Bold, color = Color.White) },
                text = {
                    Column(modifier = Modifier.fillMaxWidth().padding(top = 8.dp)) {
                        Text(text = "${tempEuro},${tempCent.toString().padStart(2, '0')} €", style = MaterialTheme.typography.headlineMedium.copy(fontWeight = FontWeight.ExtraBold), color = Color.White, modifier = Modifier.align(Alignment.CenterHorizontally))
                        Spacer(Modifier.height(24.dp))
                        Row(modifier = Modifier.fillMaxWidth().height(160.dp), horizontalArrangement = Arrangement.Center, verticalAlignment = Alignment.CenterVertically) {
                            WheelPicker(items = (0..5000).toList(), initialValue = tempEuro, onValueChanged = { tempEuro = it }, modifier = Modifier.weight(1f))
                            Text(",", style = MaterialTheme.typography.headlineLarge, color = Color.White, modifier = Modifier.padding(horizontal = 16.dp))
                            WheelPicker(items = (0..99).toList(), initialValue = tempCent, onValueChanged = { tempCent = it }, modifier = Modifier.weight(1f), labelExtractor = { it.toString().padStart(2, '0') })
                        }
                    }
                },
                confirmButton = {
                    TextButton(onClick = {
                        val newVal = "${tempEuro},${tempCent.toString().padStart(2, '0')}"
                        if (activeAmountTarget == TxAmountTarget.AMOUNT) amountText = newVal else feeText = newVal
                        activeAmountTarget = TxAmountTarget.NONE
                    }) { Text("CONFERMA", color = pickerThemeColor, fontWeight = FontWeight.Bold) }
                },
                dismissButton = {
                    TextButton(onClick = { activeAmountTarget = TxAmountTarget.NONE }) {
                        Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold)
                    }
                }
            )
        }

        if (showDatePicker) {
            DatePickerDialog(
                onDismissRequest = { showDatePicker = false },
                confirmButton = {
                    TextButton(onClick = {
                        datePickerState.selectedDateMillis?.let { millis ->
                            val d = Instant.fromEpochMilliseconds(millis).toLocalDateTime(TimeZone.currentSystemDefault()).date
                            val s = "${d.dayOfMonth.toString().padStart(2, '0')}/${d.monthNumber.toString().padStart(2, '0')}/${d.year}"
                            dateTFV = TextFieldValue(s, TextRange(s.length))
                        }
                        showDatePicker = false
                    }) { Text("OK", fontWeight = FontWeight.Bold, color = pickerThemeColor) }
                },
                dismissButton = {
                    TextButton(onClick = { showDatePicker = false }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
                },
                colors = DatePickerDefaults.colors(containerColor = Color(0xFF1E1B4B))
            ) {
                DatePicker(
                    state = datePickerState,
                    colors = DatePickerDefaults.colors(
                        containerColor = Color(0xFF1E1B4B),
                        titleContentColor = Color.White,
                        headlineContentColor = Color.White,
                        weekdayContentColor = Color(0xFFA0A0A0),
                        subheadContentColor = Color.White,
                        yearContentColor = Color.White,
                        currentYearContentColor = pickerThemeColor,
                        selectedYearContentColor = Color.White,
                        selectedYearContainerColor = pickerThemeColor,
                        dayContentColor = Color.White,
                        selectedDayContentColor = Color.White,
                        selectedDayContainerColor = pickerThemeColor,
                        todayContentColor = pickerThemeColor,
                        todayDateBorderColor = pickerThemeColor
                    )
                )
            }
        }

        if (showWebSearch) {
            WebImagePickerPopup(
                initialQuery = merchant,
                onDismiss = { showWebSearch = false },
                onImageSelected = { url ->
                    logoUri = url
                    logoEmoji = ""
                    manualLogoSet = true
                    showWebSearch = false
                }
            )
        }

        val hapticPopup = LocalHapticFeedback.current

        if (showPendingCashPopup) {
            var subAmountText by remember { mutableStateOf("") }
            var subMerchant by remember { mutableStateOf("") }
            var subCategorySearchText by remember { mutableStateOf("") }
            var subCategoryMenuOpen by remember { mutableStateOf(false) }
            val subCatInteractionSource = remember { MutableInteractionSource() }
            val isSubCatFocused by subCatInteractionSource.collectIsFocusedAsState()

            LaunchedEffect(isSubCatFocused) {
                if (isSubCatFocused) subCategoryMenuOpen = true
            }

            AlertDialog(
                onDismissRequest = { showPendingCashPopup = false },
                shape = RoundedCornerShape(28.dp),
                containerColor = Color.White.copy(alpha = 0.12f),
                title = { Text("Dettaglio Sotto-Spesa", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White) },
                text = {
                    Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                        OutlinedTextField(
                            value = subMerchant,
                            onValueChange = { subMerchant = it },
                            label = { Text("Cosa hai comprato?", color = Color(0xFFA0A0A0)) },
                            singleLine = true,
                            modifier = Modifier.fillMaxWidth(),
                            shape = RoundedCornerShape(14.dp),
                            colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = pickerThemeColor, unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
                        )
                        OutlinedTextField(
                            value = subAmountText,
                            onValueChange = { if (it.all { c -> c.isDigit() || c == ',' || c == '.' }) subAmountText = it },
                            label = { Text("Importo (€)", color = Color(0xFFA0A0A0)) },
                            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                            singleLine = true,
                            modifier = Modifier.fillMaxWidth(),
                            shape = RoundedCornerShape(14.dp),
                            colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = pickerThemeColor, unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
                        )
                        Box(modifier = Modifier.fillMaxWidth()) {
                            OutlinedTextField(
                                value = subCategorySearchText,
                                onValueChange = { subCategorySearchText = it; subCategoryMenuOpen = true },
                                label = { Text("Categoria (Opzionale)", color = Color(0xFFA0A0A0)) },
                                interactionSource = subCatInteractionSource,
                                trailingIcon = { IconButton(onClick = { subCategoryMenuOpen = !subCategoryMenuOpen }) { Icon(if (subCategoryMenuOpen) Icons.Default.KeyboardArrowUp else Icons.Default.KeyboardArrowDown, null, tint = Color.White) } },
                                modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(14.dp),
                                colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = pickerThemeColor, unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
                            )
                            DropdownMenu(
                                expanded = subCategoryMenuOpen && isSubCatFocused,
                                onDismissRequest = { subCategoryMenuOpen = false },
                                properties = PopupProperties(focusable = false),
                                modifier = Modifier.fillMaxWidth(0.8f).heightIn(max = 200.dp).background(Color(0xFF1C1C1E))
                            ) {
                                val filtered = categories.filter { !it.isDeleted && it.name.contains(subCategorySearchText, ignoreCase = true) }
                                filtered.forEach { cat ->
                                    DropdownMenuItem(text = { Text(cat.name, color = Color.White) }, onClick = { subCategorySearchText = cat.name; subCategoryMenuOpen = false })
                                }
                            }
                        }
                    }
                },
                confirmButton = {
                    Button(
                        onClick = {
                            val cents = parseEuroToCentsSafe(subAmountText)
                            val totalMainCents = parseEuroToCentsSafe(amountText)
                            val currentPendingCash = pendingCashTxs.sumOf { it.amountCents }

                            if (cents > 0) {
                                if ((currentPendingCash + cents) > totalMainCents) {
                                    hapticPopup.performHapticFeedback(HapticFeedbackType.LongPress)
                                    showCashExceededWarning = true
                                } else {
                                    val catId = categories.firstOrNull { it.name.equals(subCategorySearchText.trim(), ignoreCase = true) }?.id ?: "default"
                                    val catName = categories.firstOrNull { it.id == catId }?.name ?: "Altro"
                                    pendingCashTxs.add(PendingCashTx(cents, subMerchant.trim().ifBlank { "Sotto-spesa" }, catId, catName, ""))
                                    showPendingCashPopup = false
                                }
                            }
                        },
                        shape = RoundedCornerShape(14.dp),
                        colors = ButtonDefaults.buttonColors(containerColor = pickerThemeColor, contentColor = Color.White)
                    ) { Text("AGGIUNGI", fontWeight = FontWeight.Bold) }
                },
                dismissButton = { TextButton(onClick = { showPendingCashPopup = false }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) } }
            )
        }
    }

    if (showSaldoWarning) {
        AlertDialog(
            onDismissRequest = { showSaldoWarning = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = { Text("Saldo Insufficiente ⚠️", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.error) },
            text = { Text("Stai cercando di spendere ${formatEuroFromCents(parseEuroToCentsSafe(amountText))}, ma il tuo saldo disponibile in questo conto è di soli ${formatEuroFromCents(saldoDisponibile)}.", color = Color(0xFFA0A0A0)) },
            confirmButton = { TextButton(onClick = { showSaldoWarning = false }) { Text("HO CAPITO", color = Color.White, fontWeight = FontWeight.Bold) } }
        )
    }

    if (showCashWarning) {
        AlertDialog(
            onDismissRequest = { showCashWarning = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = { Text("Importo Errato ⚠️", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.error) },
            text = { Text("Il totale delle sotto-spese inserite (${formatEuroFromCents(pendingCashTxs.sumOf { it.amountCents })}) supera l'importo totale che hai dichiarato per l'intera operazione (${formatEuroFromCents(parseEuroToCentsSafe(amountText))}).", color = Color(0xFFA0A0A0)) },
            confirmButton = { TextButton(onClick = { showCashWarning = false }) { Text("HO CAPITO", color = Color.White, fontWeight = FontWeight.Bold) } }
        )
    }

    if (showCashExceededWarning) {
        AlertDialog(
            onDismissRequest = { showCashExceededWarning = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = { Text("Limite superato ⚠️", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.error) },
            text = { Text("L'inserimento che stai tentando di fare supera l'importo totale della transazione principale.", color = Color(0xFFA0A0A0)) },
            confirmButton = {
                TextButton(onClick = { showCashExceededWarning = false }) { Text("HO CAPITO", color = Color.White, fontWeight = FontWeight.Bold) }
            }
        )
    }

    if (showSmartEmergencyWarning) {
        val finalAmount = parseEuroToCentsSafe(amountText)
        AlertDialog(
            onDismissRequest = { showSmartEmergencyWarning = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = { Text("Fondo di Emergenza Necessario 🛡️", fontWeight = FontWeight.Bold, color = Color(0xFF60A5FA)) },
            text = {
                Text(
                    text = "Il tuo saldo disponibile è di ${formatEuroFromCents(saldoDisponibile)}. Per coprire l'intera spesa di ${formatEuroFromCents(finalAmount)} preleveremo automaticamente i mancanti ${formatEuroFromCents(pendingEmergencyDeficit)} dal tuo Scudo.\n\nVuoi procedere?",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color.White
                )
            },
            confirmButton = {
                TextButton(onClick = {
                    showSmartEmergencyWarning = false

                    val finalAmountChecked = parseEuroToCentsSafe(amountText)
                    val txEpochDay = parseDayMonthYearSafe(dateTFV.text) ?: today.toEpochDays().toLong()
                    val doppione = latest.firstOrNull { tx ->
                        !tx.isDeleted && tx.type == mode && tx.dateEpochDay == txEpochDay && tx.amountCents == finalAmountChecked && tx.merchantKey?.trim()?.equals(merchant.trim(), ignoreCase = true) == true
                    }
                    if (!isTransfer && !isVaporizedTransaction && doppione != null) {
                        showDuplicateWarning = doppione
                    } else {
                        performSaveTransaction(true, pendingEmergencyDeficit)
                    }
                }) { Text("PROCEDI", color = Color(0xFF60A5FA), fontWeight = FontWeight.Bold) }
            },
            dismissButton = { TextButton(onClick = { showSmartEmergencyWarning = false }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) } }
        )
    }

    if (showDuplicateWarning != null) {
        AlertDialog(
            onDismissRequest = { showDuplicateWarning = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = { Text("Possibile Doppione ⚠️", fontWeight = FontWeight.Bold, color = Color(0xFFF59E0B)) },
            text = {
                Text("Hai già registrato un'operazione per **${showDuplicateWarning!!.merchantKey}** di **${formatEuroFromCents(showDuplicateWarning!!.amountCents)}** in data odierna.\n\nVuoi aggiungerla lo stesso?", color = Color(0xFFA0A0A0))
            },
            confirmButton = {
                Button(
                    onClick = {
                        val useEmergency = pendingEmergencyDeficit > 0L
                        val def = pendingEmergencyDeficit
                        showDuplicateWarning = null
                        performSaveTransaction(useEmergency, def)
                    },
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFF59E0B))
                ) { Text("SÌ, INSERISCI", fontWeight = FontWeight.Bold, color = Color.White) }
            },
            dismissButton = {
                TextButton(onClick = { showDuplicateWarning = null }) {
                    Text("ANNULLA", color = Color(0xFFA0A0A0))
                }
            }
        )
    }
}
